import React from 'react';
import ReactDOM from 'react-dom/client'; //react 18
import { Provider } from 'react-redux';
import store from './src/stores/redux/store';
// Application Styles
import './src/styles/app.scss';
import App from './src/app';
import { BrowserRouter } from 'react-router-dom';
//Vendor Syles
import './Vendor';

const root = ReactDOM.createRoot(document.getElementById('root'));
//react 18
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    // </React.StrictMode>
);
